/**
 * Created with IntelliJ IDEA.
 * User: shlomif
 * Date: 5/4/14
 * Time: 9:48 AM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
    "use strict";

    var Backbone = require("backbone");

    var SoundStateModel = Backbone.Model.extend({
        defaults: {
            enabled: true
        },
        name: "SoundStateModel"
    });

    return SoundStateModel;
});
